import React from "react";
import { Stepper, Step } from "@progress/kendo-react-layout";
import { Grid } from "@material-ui/core";
import "./style.css";

const CustomStepItem = (props) => {
  return (
    <Step {...props}>
      <span className="k-step-indicator">
        <img src={props.icon} alt="" className="item-step-icon-reliable"></img>
      </span>
      <span className="k-step-label k-step-text label-stepper">
        {props.title}
      </span>
    </Step>
  );
};

const StepperTitle = (props) => {
  const { title, subtitle, instruction } = props;

  return (
    <div className="center-container">
      <div className="stepper-title">
        <h3 className="user-register-title">{title}</h3>
        <h4 className="user-register-steps">{subtitle}</h4>
        <h5>{instruction}</h5>
      </div>
    </div>
  );
};

const StepperPure = (props) => {
  const { title, subtitle, steps, selectedStep, instruction } = props;

  return (
    <>
      <Grid
        container
        className="stepper-container"
        xs={12}
        lg={12}
        md={12}
        sm={12}
        es={12}
      >
        <div className="steps center stepper-movil">
          <Stepper value={selectedStep} items={steps} item={CustomStepItem} />
        </div>
      </Grid>
      {/* <StepperTitle
        title={title}
        subtitle={subtitle}
        instruction={instruction}
      /> */}
    </>
  );
};

export default StepperPure;
